import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, ShoppingCart, Download, Play, ShieldCheck } from 'lucide-react';
export function PriceCTA() {
  return <section id="checkout" className="py-24 px-6 bg-white border-t border-charcoal/5" data-id="element-106">
      <div className="max-w-3xl mx-auto text-center" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="bg-linen p-8 md:p-12 rounded-3xl border border-charcoal/10 shadow-xl relative overflow-hidden" data-id="element-108">
          {/* Urgency Banner */}
          <div className="absolute top-0 left-0 right-0 bg-terracotta/10 border-b border-terracotta/20 py-2 px-4 flex items-center justify-center gap-2 text-terracotta text-sm font-bold uppercase tracking-wide" data-id="element-109">
            <Clock className="w-4 h-4" data-id="element-110" />
            Launch week price — this discount won't last
          </div>

          <div className="mt-8" data-id="element-111">
            <p className="text-lg text-charcoal/70 mb-8 max-w-md mx-auto font-serif italic" data-id="element-112">
              You're not failing. You're overloaded. This reset gives you
              scripts + anchors so calm doesn't depend on your mood.
            </p>

            <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-2" data-id="element-113">
              $6.36{' '}
              <span className="text-xl font-sans font-normal text-charcoal/40 align-middle line-through" data-id="element-114">
                $27
              </span>
            </h2>

            <div className="inline-flex items-center gap-2 mb-8" data-id="element-115">
              <span className="bg-green-100 text-green-800 text-sm font-bold px-3 py-1 rounded-full" data-id="element-116">
                You save $20.64 (76% off)
              </span>
            </div>

            {/* How It Works Steps */}
            <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 mb-10 text-charcoal/80" data-id="element-117">
              <div className="flex flex-col items-center gap-2" data-id="element-118">
                <div className="w-10 h-10 rounded-full bg-white border border-charcoal/10 flex items-center justify-center text-muted-blue shadow-sm" data-id="element-119">
                  <ShoppingCart className="w-5 h-5" data-id="element-120" />
                </div>
                <span className="text-sm font-medium" data-id="element-121">
                  Buy the Reset ($6.36)
                </span>
              </div>

              <div className="hidden md:block w-12 h-px bg-charcoal/10" data-id="element-122" />

              <div className="flex flex-col items-center gap-2" data-id="element-123">
                <div className="w-10 h-10 rounded-full bg-white border border-charcoal/10 flex items-center justify-center text-muted-blue shadow-sm" data-id="element-124">
                  <Download className="w-5 h-5" data-id="element-125" />
                </div>
                <span className="text-sm font-medium" data-id="element-126">
                  Get instant PDF access
                </span>
              </div>

              <div className="hidden md:block w-12 h-px bg-charcoal/10" data-id="element-127" />

              <div className="flex flex-col items-center gap-2" data-id="element-128">
                <div className="w-10 h-10 rounded-full bg-white border border-charcoal/10 flex items-center justify-center text-muted-blue shadow-sm" data-id="element-129">
                  <Play className="w-5 h-5 ml-0.5" data-id="element-130" />
                </div>
                <span className="text-sm font-medium" data-id="element-131">Start Day 0 tonight</span>
              </div>
            </div>

            <a href="https://www.betterbysteps.com/cart/44196368351325:1" target="_blank" rel="noopener noreferrer" className="group w-full md:w-auto inline-flex items-center justify-center gap-3 bg-muted-blue hover:bg-muted-blue-dark text-white text-lg font-bold px-8 py-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 mb-4" data-id="element-132">
              <span data-id="element-133">Get The 14‑Day Quiet House Reset</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-134" />
            </a>

            <p className="text-sm text-charcoal/60 mb-6" data-id="element-135">
              Instant PDF Download • Secure Checkout
            </p>

            {/* Guarantee Badge */}
            <div className="flex items-center justify-center gap-2 text-charcoal/70 text-sm mb-8 bg-white/50 py-2 px-4 rounded-full inline-flex border border-charcoal/5" data-id="element-136">
              <ShieldCheck className="w-4 h-4 text-sage" data-id="element-137" />
              <span data-id="element-138">
                No-questions-asked refund if it doesn't help. Just email me.
              </span>
            </div>

            

            <div className="mt-12 pt-8 border-t border-charcoal/10" data-id="element-139">
              <h3 className="text-2xl font-serif font-bold text-charcoal mb-4" data-id="element-140">
                Imagine tonight.
              </h3>
              <p className="text-charcoal/80 max-w-lg mx-auto leading-relaxed" data-id="element-141">
                Kids in bed. House quiet. And you didn't raise your voice once.
                Not because you tried harder—because the decisions were already
                made. That's what this reset builds. One anchor at a time.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}